import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // This hook gives us the current URL pathname
  const { pathname } = useLocation();

  // useEffect runs code whenever something changes.
  // Here, it runs whenever the 'pathname' changes.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // This component doesn't render anything visually
  return null;
};

export default ScrollToTop;